// Single source of truth for Aurumward branding — canonical asset set.
// Do NOT hard-code logo/icon paths in components — import from here.
export const brandName = "Aurumward";
export const brandTagline = "Risk the journey. Earn the legend.";

// Full landscape banner (compass emblem + "AURUMWARD" on the brand background).
// Use for the landing hero and any self-contained banner placement.
export const brandBanner = "/aurumward-banner-full.png";

// Transparent wordmark lockup. Use over dark or light panels: header, auth, reports,
// sponsor pages, splash — anywhere a baked background must NOT appear.
export const brandLogoFull = "/aurumward-wordmark.png";

// Square compass emblem. Use for favicon, PWA/app icons, avatars, compact emblems.
export const brandIconSquare = "/aurumward-emblem-512.png";

// Compact emblem mark — use only where the full wordmark cannot fit.
export const brandLogoCompact = "/aurumward-emblem-512.png";

// Maskable variant for Android adaptive icons.
export const brandIconMaskable = "/aurumward-icon-maskable.png";

export const brandTheme = { themeColor: "#0D1812", backgroundColor: "#0D1812", gold: "#B5A642" };
